import { Avatar, Badge, Button, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, ListSubheader, Popover, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react'
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { getNotifications, StudentActions } from '../../store/StudentAction';
import UserAvatar from '../../utils/Avatar/Avatar';
import moment from 'moment';
import './notifications.scss'
import VideoCallRoundedIcon from '@mui/icons-material/VideoCallRounded';
import TaskRoundedIcon from '@mui/icons-material/TaskRounded';
import TourRoundedIcon from '@mui/icons-material/TourRounded';
import { NavigationContext } from '../adminDashboard/admin';
import PlacementApi from '../../store/services/placement';
import UserApi from '../../store/services/user';
import { useNavigate } from 'react-router-dom';
import { createNotifictions } from '../../utils/helperFunction';
import EventNotificationModal from './eventNotificationModal/eventNotificationModal';



const Notifications = () => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const dispatch = useAppDispatch()
    const notifications = useAppSelector((state: any) => state.user.notifications)
    const navContext = useContext(NavigationContext);
    const userDetails = useAppSelector((state: any) => state.user.user)
    const events = useAppSelector((state) => state.user.events)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notifications-popover' : undefined;
    const fetchNotifications = async () => {
        await dispatch(getNotifications())
    }

    const getListItems = (notification: any) => {
        switch (notification.NotificationType) {
            case 'TM':
                return (
                    <ListItem className='flex flex-column'>
                        <div className='flex justify-content-between'>
                            <ListItemAvatar className='mt-1'>
                                <Avatar className="avatarNotification" >
                                    <VideoCallRoundedIcon></VideoCallRoundedIcon>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                className='m-0'
                                primary={
                                    <>
                                        <p className='font-weight-700 m-0 itemTitle'>{notification.Message}</p>
                                    </>
                                }
                                secondary={
                                    <React.Fragment>
                                        <span className='align-items-center flex gray-color itemSubtitle m-0'>{moment(notification.DateCreated).fromNow()} <span className="dot m-1"></span> Team Meeting</span>
                                    </React.Fragment>
                                }
                            />
                        </div>
                        <div className='mt-2' >
                            {
                                events.length > 0 ? events.filter((elm: any) => elm._id === notification.EventId).length > 0 ? <EventNotificationModal notifications={notification} event={events.filter((elm: any) => elm._id === notification.EventId)[0]} fetchNotifications={() => {
                                    fetchNotifications()
                                }}></EventNotificationModal> : <></> : <></>
                            }

                        </div>

                    </ListItem>
                )
            case 'RQ':
                return (
                    <ListItem className='flex flex-column'>
                        <div className='flex justify-content-between'>
                            <ListItemAvatar className='mt-1'>
                                <Avatar className="avatarNotification" >
                                    <TaskRoundedIcon></TaskRoundedIcon>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                className='m-0'
                                primary={
                                    <>
                                        <p className='font-weight-700 m-0 itemTitle'>{notification.Message}</p>
                                    </>
                                }
                                secondary={
                                    <React.Fragment>
                                        <span className='align-items-center flex gray-color itemSubtitle m-0'>{moment(notification.DateCreated).fromNow()} <span className="dot m-1"></span> Request</span>
                                    </React.Fragment>
                                }
                            />
                        </div>
                        {
                             userDetails.isAdmin && <div className='flex justify-content-end mt-2 w-100'>
                             <Button variant='contained' size='small' className='mx-2' onClick={() => {
                                 navContext.assignContent("Requests")
                             }}>View</Button>
                         </div>
                        }

                        
                    </ListItem>
                )
            case 'PV':
                return (
                    <ListItem className='flex flex-column'>
                        <div className='flex justify-content-between'>
                            <ListItemAvatar className='mt-1'>
                                <Avatar className="avatarNotification" >
                                    <TourRoundedIcon></TourRoundedIcon>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                className='m-0'
                                primary={
                                    <>
                                        <p className='font-weight-700 m-0 itemTitle'>{notification.Message}</p>
                                    </>
                                }
                                secondary={
                                    <React.Fragment>
                                        <span className='align-items-center flex gray-color itemSubtitle m-0'>{moment(notification.DateCreated).fromNow()} <span className="dot m-1"></span> Team Meeting</span>
                                    </React.Fragment>
                                }
                            />
                        </div>

                        <div className='mt-2'>
                            {
                                events.length > 0 ? events.filter((elm: any) => elm._id === notification.EventId).length > 0 ? <EventNotificationModal notifications={notification} event={events.filter((elm: any) => elm._id === notification.EventId)[0]} fetchNotifications={() => {
                                    fetchNotifications()
                                }}></EventNotificationModal> : <></> : <></>
                            }
                        </div>
                    </ListItem>
                ) 
        }
    }
    useEffect(() => {
        fetchNotifications()
    }, [])
    return (
        <div>
            <IconButton aria-label="Notifications Button" className='text-Primary m-2' onClick={handleClick}>
                <Badge badgeContent={notifications.filter((elm: any) => !Object.keys(elm).includes('Updated')).length} color="primary">
                    <NotificationsActiveRoundedIcon />
                </Badge>
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            Notifications
                        </ListSubheader>
                    }>
                    {
                        notifications.length > 0 &&
                        [...notifications].sort((a: any, b: any) => new Date(a.DateCreated) > new Date(b.DateCreated) ? -1 : 1).map((elm: any, index: any) => {
                            return <div key={index}>
                                {getListItems(elm)}
                            </div>
                        })
                    }
                </List>
            </Popover>
        </div>
    )

}
export default Notifications;